import { create } from "apisauce";
import apiConfig from "../config/api";


const baseUrl = apiConfig.BASE_URL + (Number.isInteger(apiConfig.PORT) ? ":" + apiConfig.PORT : "") + apiConfig.API_PATH;
const apiClient = create({
    baseURL:  baseUrl
});

export default apiClient;